"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");
var _theme = require("@vds/theme");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var defaultProps = {
  /**
   * @ignore
   */
  disabled: false,
  /**
   * @ignore
   */
  selectedStateDoubleBorder: false,
  /**
   * @ignore
   */
  outOfStock: false,
  /**
   * @ignore
   */
  inverted: false,
  /**
   * @ignore
   */
  colorConfig: _theme.colors
};
var propTypes = {
  disabled: _propTypes["default"].bool,
  selected: _propTypes["default"].bool,
  inverted: _propTypes["default"].bool,
  //1.0
  selectedStateDoubleBorder: _propTypes["default"].bool,
  outOfStock: _propTypes["default"].bool,
  /**
   * @ignore
   */
  colorConfig: _propTypes["default"].object,
  //Deprecated
  checked: _propTypes["default"].bool
};
var StyledWrapper = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  displayName: "StyledWrapper",
  componentId: "sc-1xzk6-0"
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  box-sizing: border-box;\n  display: block;\n  height: 100%;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n"])));
var SelectStyles = /*#__PURE__*/(0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  border: ", " solid\n    ", ";\n  border-radius: 50%;\n  box-shadow: ", ";\n  box-sizing: border-box;\n  display: block;\n  left: 50%;\n  height: 100%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n"])), (0, _javascriptStyleHelpers.calculateRem)(1), function (_ref) {
  var colorConfig = _ref.colorConfig,
    inverted = _ref.inverted;
  return inverted ? colorConfig.white : colorConfig.black;
}, function (_ref2) {
  var colorConfig = _ref2.colorConfig,
    inverted = _ref2.inverted;
  return "inset 0 0 0 ".concat((0, _javascriptStyleHelpers.calculateRem)(2), " ").concat(inverted ? colorConfig.black : colorConfig.white);
});

//If its out of stock,
var offsetInner = 2;
var CheckedShape = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  displayName: "CheckedShape",
  componentId: "sc-1xzk6-1"
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  ", ";\n  ", ";\n"])), SelectStyles, function (_ref3) {
  var selectedStateDoubleBorder = _ref3.selectedStateDoubleBorder,
    outOfStock = _ref3.outOfStock,
    selected = _ref3.selected,
    colorConfig = _ref3.colorConfig,
    inverted = _ref3.inverted;
  return (selectedStateDoubleBorder || outOfStock) && "\n  &:after {\n    position: absolute;\n    content:'';\n    top: ".concat(offsetInner, "px;\n    left: ").concat(offsetInner, "px;\n    height: calc(100% - 6px);\n    width: calc(100% - 6px);\n    background: transparent;\n    border-radius: 50%;\n    border: 1px solid ").concat(selected && !inverted ? colorConfig.black : selected && inverted ? colorConfig.white : colorConfig.coolGray6, ";\n  }\n  ");
});
var DisabledShape = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  displayName: "DisabledShape",
  componentId: "sc-1xzk6-2"
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  ", ";\n  ", ";\n  &::before {\n    background-color: ", ";\n    content: \"\";\n    height: ", ";\n    left: 50%;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%) rotate(-45deg);\n    width: 100%;\n    z-index: 1;\n  }\n"])), SelectStyles, function (_ref4) {
  var outOfStock = _ref4.outOfStock,
    selected = _ref4.selected,
    colorConfig = _ref4.colorConfig,
    inverted = _ref4.inverted;
  return outOfStock && "\n    border: ".concat((0, _javascriptStyleHelpers.calculateRem)(1), " solid ").concat(selected && !inverted ? colorConfig.black : selected && inverted ? colorConfig.white : colorConfig.coolGray6, ";\n    ");
}, function (_ref5) {
  var selected = _ref5.selected,
    outOfStock = _ref5.outOfStock,
    colorConfig = _ref5.colorConfig,
    inverted = _ref5.inverted;
  return outOfStock && !selected ? colorConfig.coolGray6 : outOfStock && selected && inverted ? colorConfig.white : colorConfig.black;
}, (0, _javascriptStyleHelpers.calculateRem)(1));

/**
 * @ignore
 */
var ColorIcon = function ColorIcon(props) {
  var disabled = props.disabled,
    checked = props.checked,
    selected = props.selected,
    selectedStateDoubleBorder = props.selectedStateDoubleBorder,
    outOfStock = props.outOfStock,
    colorConfig = props.colorConfig,
    inverted = props.inverted;
  var isSelected = checked || selected;
  return /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, (isSelected || outOfStock) && /*#__PURE__*/_react["default"].createElement(CheckedShape, {
    selected: isSelected,
    outOfStock: outOfStock,
    selectedStateDoubleBorder: selectedStateDoubleBorder,
    colorConfig: colorConfig,
    inverted: inverted
  }), (disabled || outOfStock) && /*#__PURE__*/_react["default"].createElement(DisabledShape, {
    selected: isSelected,
    outOfStock: outOfStock,
    colorConfig: colorConfig,
    inverted: inverted
  }));
};
ColorIcon.defaultProps = defaultProps;
ColorIcon.propTypes = propTypes;
var _default = exports["default"] = ColorIcon;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/inputs/dist/cjs/components/RadioSwatch/ColorIcon.js
// module id = 1454
// module chunks = 0